import { createAuthenticatedAxiosInstance } from "../auth/auth.slice";

const baseUrl = import.meta.env.VITE_API_URL;

export const dataResetService = {
    /** How many records each area holds, so the UI can show what is at stake. */
    counts: async () => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.get(baseUrl + "data/counts");
        return response.data;
    },

    /**
     * Permanently deletes the chosen areas. The password is the signed-in
     * user's own — the server re-verifies it, so this is a real gate rather
     * than a client-side speed bump.
     */
    clear: async ({ areas, password }) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.post(baseUrl + "data/clear", {
            areas,
            password,
        });
        return response.data;
    },
};
